import { ApiObservationHpsOrganizationInterface } from 'app/api/api.interface';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'nlf-ors-hps-report-organization',
  templateUrl: './report-organization.component.html',
  styleUrls: ['./report-organization.component.css']
})
export class NlfOrsHpsReportOrganizationComponent implements OnInit {

  @Input() organization: ApiObservationHpsOrganizationInterface;
  constructor() { }

  ngOnInit() {
  }

}
